import { SimpleModalConfig } from "@app/shared/services/modal.service";

export type PublishedFollowUp = "next" | "list" | "stay";

export interface PublishedDialog {
  readonly config: SimpleModalConfig;
  readonly primary: PublishedFollowUp;
  readonly secondary: PublishedFollowUp;
}

export function publishedDialog(
  priceTitle: string,
  channel: string,
  next: { readonly title: string } | null,
): PublishedDialog {
  const live = channel
    ? `"${priceTitle}" is live on ${channel}.`
    : `"${priceTitle}" is live.`;
  if (next) {
    return {
      config: {
        title: "Published",
        message: `${live} "${next.title}" is staged and ready to publish next.`,
        primaryButtonText: "Next price to publish",
        secondaryButtonText: "Back to list",
        showCloseButton: true,
      },
      primary: "next",
      secondary: "list",
    };
  }
  return {
    config: {
      title: "Published",
      message: live,
      primaryButtonText: "Back to list",
      secondaryButtonText: "Stay on this price",
      showCloseButton: true,
    },
    primary: "list",
    secondary: "stay",
  };
}
